export default __webpack_public_path__ + "static/media/data_¿que-mide.868c23cd.png";